export enum FRONT_END_APP {
  ADMIN = 'ADMIN',
  GESTOR = 'GESTOR',
  ACADEMICO = 'ACADEMICO',
}
